<template>
  <div>
    <el-dropdown trigger="click" @command="openChat">
      <span class="el-dropdown-link">
        <el-badge v-if="messageNumber" :value="messageNumber" class="item">
          <i class='fa fa-bell fa-lg'></i>
        </el-badge>
        <i v-else class="fa fa-bell fa-lg"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <template v-if="chats.length">
          <el-dropdown-item
              v-for="(chat, key) in chats"
              :key="key"
              :command="chat.user_id"
          >{{ chat.user_chat }} &nbsp; <el-tag>{{ chat.count_unread }}</el-tag>
          </el-dropdown-item>
        </template>
        <template v-else>
          <el-dropdown-item>
            No hay nuevos chats
          </el-dropdown-item>
        </template>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  name: "SupportNotifications",
  props: ['chats', 'isstudent'],
  data() {
    return {

    }
  },
  methods: {
    openChat(user_id) {
      if (!this.isstudent) {
        if (user_id) {
          window.location.href = `/support-online-chat/${user_id}`;
        } else{
          window.location.href = `/support-online-chat`;
        }
      } else {
        if (user_id) {
          window.location.href = `/online-chat/${user_id}`;
        } else{
          window.location.href = `/online-chat`;
        }
      }
    }
  },
  computed: {
    messageNumber(){
      let count = 0;
      if(this.chats){
        this.chats.forEach(chat => {
          count += parseInt(chat.count_unread);
        });
      }
      return count;
    },
  },
}
</script>

<style>
  .navbar .navbar-nav > .navbar-chat > #bellchat,
  #bellchat .navbar-chat > div {
    padding: 10px 10px;
    margin: 10px 3px;
    position: relative;
  }
  #bellchat-mobile li{
    float:right;
    padding: 5px 10px 10px;
    margin: 10px 3px;
    position: relative;
  }
  .el-badge__content {
    line-height:14px!important;
    border-color:transparent!important;
  }
</style>
